// extracted by mini-css-extract-plugin
export default {"labelSmall":"Select_labelSmall__YH0ub","label":"Select_label__dwCt3"};